import React from 'react';
import { useQuery } from '@apollo/client';
import { Typography } from '@mui/material';
import { MoDismissableBanner } from '@motivo/guanyin/src/components';
import { OrganizationRoleEnum } from '@motivo/guanyin/src/lookup';
import useViewer from ':src/hooks/useViewer';
import { organizationSetupChecklistQuery } from ':src/domains/dashboard/queries';

export default function OnboardingDemoBanner() {
  const { viewer, isLoggedIn } = useViewer();
  const isAdminRole = viewer.organizationRoleId === OrganizationRoleEnum.ADMIN;
  const { data } = useQuery(organizationSetupChecklistQuery, {
    skip: !isLoggedIn || !isAdminRole,
  });

  if (!data?.viewer.organization?.isOnboarding) return null;

  return (
    <MoDismissableBanner isOpen>
      <Typography variant="body2" color="inherit" fontWeight={600} textAlign="center">
        Want to learn more about how to use Motivo?{' '}
        <a href="https://mtvh.co/employer-dashboard-overview" target="_blank" rel="noreferrer">
          Watch a demo
        </a>
      </Typography>
    </MoDismissableBanner>
  );
}
